import React from 'react';
import styles from './drawerContent.module.scss';
import { decodeBase64Id } from '@/helpers/decodeBase64Id';
import { Link } from '@/i18n/navigation';
import Image from 'next/image';
import { RenderCollectionsProps } from '@/types/headerBottomDriver.type';
import { slugify } from '../slug';

const renderCollections = ({
  collections,
  isBottom,
  closeButton,
  handleTabChange,
  tab,
}: RenderCollectionsProps) => {
  return collections
    ?.filter((col: any) => col?.node?.isInCatalog)
    ?.filter((col: any) => col?.node?.isBottom === isBottom)
    ?.map((col: any) => {
      const item = col.node;
      const link = `/collection/${decodeBase64Id(item.id)}-${slugify(item.name)}`;
      return (
        <Link
          href={link}
          key={item.id}
          onClick={closeButton}
          onMouseEnter={() => handleTabChange(item.id)}
          className={`${styles.drawer__category} ${tab === item.id ? styles.categoryActive : ''}`}
        >
          <div className={styles.drawer__text}>
            <Image
              src={item?.backgroundImage?.url || '/'}
              alt={item.name}
              width={20}
              height={20}
              className={styles.brandLogo}
            />
            <p>{item.name}</p>
          </div>
        </Link>
      );
    });
};

export default renderCollections;
